import React from 'react'
import { bannerImg } from "../../assets/index";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      {/* Decorative Background Shape */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[320px] h-[280px] lg:w-[500px] lg:h-[500px] bg-gradient-to-r from-[#1e2024] to-[#202327] shadow-shadowOne rounded-lg opacity-90"></div>

      {/* Main Image */}
      <img
        className="w-full max-w-[300px] aspect-[3/4] lg:max-w-[500px] z-10 object-cover rounded-lg shadow-xl"
        src={bannerImg}
        alt="A professional portrait of a software developer."
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

export default RightBanner